import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-top-left-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("g", { fill: "currentColor", transform: "matrix(-1 0 0 1 8 3)" },
            React.createElement("path", { d: "M-1.5 0h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1Z" }),
            React.createElement("rect", { width: 1, height: 7, x: 4, rx: 0.5 })),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M13 13 3.5 3.5" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
